import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { translations } from '../../data/translation'; // Import the translations
import AlertModal from '../../components/alertModal';
import { resizeLegalIframe } from '../../utils/legalIframeResize';

export default function UserSignUp(props) {
  const language = useSelector(state => state.language.language);
  const t = translations[language];

  // 체크박스 상태 관리
  const [allChecked, setAllChecked] = useState(false);
  const [serviceChecked, setServiceChecked] = useState(false); // defaultChecked 제거, false로 변경
  const [privacyChecked, setPrivacyChecked] = useState(false);

  // 모달 상태 관리
  const [modalOpen, setModalOpen] = useState(false);
  const [modalInfo, setModalInfo] = useState({
    isCancel: false,
    isConfirm: true,
    isMessage: true,
    headerMsg: '',
    actionFlag: '',
    mainMsg: '',
    action: '',
    isPercent: false,
  });
  const navigate = useNavigate();

  // 모달 닫기
  const closeModal = () => setModalOpen(false);
  const doModal = () => setModalOpen(false);

  // 전체 동의 체크박스 클릭 시
  const handleAllChecked = e => {
    const checked = e.target.checked;
    setAllChecked(checked);
    setServiceChecked(checked);
    setPrivacyChecked(checked);
  };

  // 개별 체크박스 클릭 시
  const handleServiceChecked = e => {
    const checked = e.target.checked;
    setServiceChecked(checked);
    // 하나라도 해제되면 전체동의 해제
    if (!checked || !privacyChecked) {
      setAllChecked(checked && privacyChecked);
    } else {
      setAllChecked(true);
    }
  };
  const handlePrivacyChecked = e => {
    const checked = e.target.checked;
    setPrivacyChecked(checked);
    if (!checked || !serviceChecked) {
      setAllChecked(checked && serviceChecked);
    } else {
      setAllChecked(true);
    }
  };

  // 다음 버튼 클릭 시
  const handleNext = e => {
    e.preventDefault();
    if (!serviceChecked || !privacyChecked) {
      setModalInfo({
        ...modalInfo,
        mainMsg: t.agreeTermsRequired,
        isConfirm: true,
        isCancel: false,
      });
      setModalOpen(true);
      return;
    }
    navigate('/store-content', {
      state: {
        serviceChecked,
        privacyChecked,
        allChecked,
      },
    });
  };

  return (
    <>
      <AlertModal
        open={modalOpen}
        close={closeModal}
        action={doModal}
        header={modalInfo.headerMsg}
        isConfirm={modalInfo.isConfirm}
        isMessage={modalInfo.isMessage}
        isCancel={modalInfo.isCancel}
      >
        {modalInfo.mainMsg}
      </AlertModal>
      {/* <!--location:start--> */}
      <section className="location_box">
        <ul className="location_001">
          <li>{t.home}</li>
          <li>{t.signupPage}</li>
        </ul>
      </section>
      {/* <!--location:end--> */}

      {/* <!--contents:start--> */}
      <main>
        <section className="contants_box contants_box_02">
          <h2 className="tit_01">{t.signupPage}</h2>

          {/* <!--form section:start--> */}
          <article className="contants_box_03">
            <table className="member_box">
              <tbody>
                <tr>
                  <td>
                    <label className="check_box">
                      {t.agreeToAll}
                      <input
                        type="checkbox"
                        checked={allChecked}
                        onChange={handleAllChecked}
                      />
                      <span className="check_check"></span>
                    </label>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="signup_01">
                      <label className="check_box">
                        <span className="font_red">{t.serviceTerms}</span>
                        <input
                          type="checkbox"
                          checked={serviceChecked}
                          onChange={handleServiceChecked}
                        />
                        <span className="check_check"></span>
                      </label>
                      <NavLink
                        to="/user-agreement"
                        className="button_04 button_gray_line"
                      >
                        {t.viewAll}
                      </NavLink>
                    </div>
                    <div className="signup_02 agreement_box">
                      <iframe
                        src="/agreement_wrap.html"
                        title="agreement_wrap"
                        onLoad={resizeLegalIframe}
                      ></iframe>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="signup_01">
                      <label className="check_box">
                        <span className="font_red">{t.privacyPolicyTitle}</span>
                        <input
                          type="checkbox"
                          checked={privacyChecked}
                          onChange={handlePrivacyChecked}
                        />
                        <span className="check_check"></span>
                      </label>
                      <NavLink
                        to="/user-privacy"
                        className="button_04 button_gray_line"
                      >
                        {t.viewAll}
                      </NavLink>
                    </div>
                    <div className="signup_02 agreement_box">
                      <iframe
                        src="/privacy_wrap.html"
                        title="privacy_wrap"
                        onLoad={resizeLegalIframe}
                      ></iframe>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </article>
          {/* <!--form section:end--> */}

          {/* <!--button:start--> */}
          <article className="button_box_01">
            <button
              type="button"
              className="button_01 button_02 button_red"
              onClick={handleNext}
            >
              {t.nextButton}
            </button>
          </article>
          {/* <!--button:end--> */}
        </section>
      </main>
      {/* <!--contents:end--> */}
    </>
  );
}
